originalGetProto